export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 85,
    slots: { default: 'opt' },
  },
  {
    type: 'expand',
    width: 70,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: { content: 'expandContent' },
  },
  {
    title: that.$l('INDEX.table_label_production_order_doc_type') || '文档类型',
    field: 'v_orderTechDocFileType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_production_order_file_name') || '文件名',
    field: 'fileName',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_file_remark') || '文档说明',
    field: 'remark',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_file_upload_name') ||
      '上传人姓名',
    field: 'uploadByName',
    width: 120,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_file_upload_time') ||
      '上传时间',
    field: 'uploadTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
